import React, { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Grid,
    Typography,
    Box,
    TextField,
    TablePagination
} from "@mui/material";
import Select, { components } from "react-select";
import Loader from "utils/Loader";
import OutstandingReportsController from "pages/Controller/OutstandingReportsController";
import { DateRange } from "react-date-range";
import { ClickAwayListener } from "@mui/material";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import NetAmountLineChart from "./Charts/NetAmountLineChart";
import MoreThan90DaysChart from './Charts/MoreThan90DaysChart';
import MoreThan180DaysChart from './Charts/MoreThan180DaysChart';
import ZoomWrapper from 'utils/ZoomWrapper';
import { IconButton } from '../../../node_modules/@mui/material/index';
import { Clear } from '../../../node_modules/@mui/icons-material/index';

const addSelectAllOption = (options) => [
    { label: "Select All", value: "__ALL__", isSelectAll: true },
    ...options
];

/* ================= CHECKBOX OPTION (REUSABLE) ================= */
// const CheckboxOption = (props) => {
//     const { label, amount, isSelectAll } = props.data;
//     const { isSelected, selectOption } = props;

//     const handleClick = (e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         selectOption(props.data);
//     };

//     return (
//         <button
//             type="button"
//             onMouseDown={handleClick}
//             style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 padding: "6px 10px",        // slightly compact
//                 cursor: "pointer",
//                 background: isSelectAll ? "#f5f5f5" : "#fff",
//                 border: "none",
//                 width: "100%",
//                 textAlign: "left",
//                 color: "#000",
//                 fontSize: "13px",           // ?? smaller text
//                 fontWeight: 400             // ?? normal weight
//             }}
//         >
//             <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
//                 <input
//                     type="checkbox"
//                     checked={isSelected}
//                     readOnly
//                     style={{ width: 14, height: 14, color: "#000", }}   // ?? smaller checkbox
//                 />
//                 <span style={{ fontWeight: 400, color: "#000", }}>
//                     {label}
//                 </span>
//             </div>

//             {amount && (
//                 <span
//                     style={{
//                         fontWeight: 600,         // slightly emphasized but not bold
//                         fontSize: "12px",
//                         color: "#b1005a"
//                     }}
//                 >
//                     {amount}
//                 </span>
//             )}
//         </button>
//     );
// };

const CheckboxOption = (props) => {
    const { label, amount, isSelectAll } = props.data;
    const { isSelected, selectOption, getValue } = props;

    // 🔥 FORCE Select-All checked state
    const allSelected =
        isSelectAll &&
        getValue().length > 0 &&
        getValue().length === props.options.filter(o => !o.isSelectAll).length;

    const checked = isSelectAll ? allSelected : isSelected;

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        selectOption(props.data);
    };

    return (
        <button
            type="button"
            onMouseDown={handleClick}
            style={{
                display: "flex",
                // justifyContent: "space-between",
                alignItems: "center",
                padding: "6px 10px",
                cursor: "pointer",
                background: isSelectAll ? "#f5f5f5" : "#fff",
                color: "#000",
                border: "none",
                width: "100%",
                textAlign: "left",
                fontSize: "13px"
            }}
        >
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input
                    type="checkbox"
                    checked={checked}
                    readOnly
                    style={{ width: 14, height: 14 }}
                />
                <span style={{ color: "#000", fontWeight: 400 }}>{label}</span>
            </div>

            {amount && (
                <span style={{ marginLeft: "auto", fontSize: "12px", color: "#b1005a", fontWeight: 600 }}>
                    {amount}
                </span>
            )}
        </button>
    );
};

const OutstandingReports = () => {
    const {
        outstandingData,
        summaryGraph,
        cloading,
        page,
        totalRecords,
        handleChangePage,

        zoneOptions,
        subdivisionOptions,
        customerNameOptions,

        filters,
        handleFilterChange,
        handleDateFromChange,
        handleDateToChange,
        handleCustomerSearch,
        todaysDate,
        divisionlist,
        isFromApp
    } = OutstandingReportsController();

    const [showCalendar, setShowCalendar] = useState(false);

    const clearDateRange = () => {
        setRange([
            {
                startDate: null,
                endDate: null,
                key: "selection",
            },
        ]);

        handleDateFromChange("");
        handleDateToChange("");
    };

    const [range, setRange] = useState([
        {
            startDate: filters.fromDate ? new Date(filters.fromDate) : null,
            endDate: filters.toDate ? new Date(filters.toDate) : null,
            key: "selection"
        }
    ]);

    const NoMultiValue = () => null;

    const singleLineSelectStyles = {
        menuPortal: (b) => ({ ...b, zIndex: 9999 }),

        control: (base) => ({
            ...base,
            minHeight: 38,
            height: 38,
            alignItems: "flex-start",
            paddingTop: 2
        }),

        valueContainer: (base) => ({
            ...base,
            height: 38,
            padding: "4px 8px",           // ✅ reduce vertical padding
            overflow: "hidden",
            display: "flex",
            alignItems: "flex-start",     // ✅ force top alignment
            justifyContent: "center"
        }),

        placeholder: (base) => ({
            ...base,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
            color: "#000",
            fontWeight: 500,
            marginTop: 2
        }),

        indicatorsContainer: (base) => ({
            ...base,
            height: 38
        }),

        /** ✅ FIX 1 — menu list container */
        menuList: (base) => ({
            ...base,
            padding: 0,
            textAlign: "left"        // 🔥 force left
        }),

        /** ✅ FIX 2 — each option wrapper */
        option: (base) => ({
            ...base,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "stretch",
            textAlign: "left",
            padding: 0
        })
    };

    const [isZoneOpen, setIsZoneOpen] = useState(false);
    const [isSubdivisionOpen, setIsSubdivisionOpen] = useState(false);
    const [isCustomerOpen, setIsCustomerOpen] = useState(false);
    const [zoneSearchText, setZoneSearchText] = useState("");
    const [subdivisionSearchText, setSubdivisionSearchText] = useState("");
    const [customerSearchText, setCustomerSearchText] = useState("");

    const makeClearTextOnlyIndicator = (setText) =>
        function ClearTextOnlyIndicator(props) {
            return (
                <components.ClearIndicator
                    {...props}
                    innerProps={{
                        ...props.innerProps,
                        onMouseDown: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setText("");        // ✅ clear only typed text
                        }
                    }}
                />
            );
        };

    const ZoneClearIndicator = makeClearTextOnlyIndicator(setZoneSearchText);
    const SubdivisionClearIndicator = makeClearTextOnlyIndicator(setSubdivisionSearchText);
    const CustomerClearIndicator = makeClearTextOnlyIndicator(setCustomerSearchText);

    //zones
    const excludedZones = zoneOptions.filter(
        (z) => !filters.zone.some((s) => s.value === z.value)
    );
    const selectedZoneCount = filters.zone.length;
    const zonePlaceholder = isZoneOpen
        ? `ZONE${selectedZoneCount ? ` selected (${selectedZoneCount})` : ""}`
        //  ? `ZONE${excludedZones.length ? ` excluded count (${excludedZones.length})` : ""}`
        : excludedZones.length
            ? `ZONE: Excluded: ${excludedZones.map(z => z.label).join(", ").slice(0, 45)}${excludedZones.map(z => z.label).join(", ").length > 45 ? "..." : ""}`
            : "ZONE";

    const zoneTooltip =
        excludedZones.length ? `Excluded:\n${excludedZones.map(z => z.label).join("\n")}` : "";

    //customer 
    const excludedCustomers = customerNameOptions.filter(
        (c) => !filters.customerName.some((s) => s.value === c.value)
    );
    const selectedCustomerCount = filters.customerName.length;

    const customerPlaceholder = isCustomerOpen
        // ? `GROUP PARTY NAME${excludedCustomers.length ? ` excluded count (${excludedCustomers.length})` : ""}`
        ? `GROUP PARTY NAME${selectedCustomerCount ? ` selected (${selectedCustomerCount})` : ""}`
        : excludedCustomers.length
            ? `GROUP PARTY NAME: Excluded: ${excludedCustomers.map(c => c.label).join(", ").slice(0, 45)}${excludedCustomers.map(c => c.label).join(", ").length > 45 ? "..." : ""}`
            : "GROUP PARTY NAME";

    const customerTooltip =
        excludedCustomers.length ? `Excluded:\n${excludedCustomers.map(c => c.label).join("\n")}` : "";


    //subdivision
    const excludedSubdivisions = subdivisionOptions.filter(
        (s) => !filters.subdivision.some((f) => f.value === s.value)
    );
    const selectedSubdivisionCount = filters.subdivision.length;

    const subdivisionPlaceholder = isSubdivisionOpen
        //  ? `SUBDIVISION${excludedSubdivisions.length ? ` excluded count (${excludedSubdivisions.length})` : ""}`
        ? `SUBDIVISION${selectedSubdivisionCount ? ` selected (${selectedSubdivisionCount})` : ""}`
        : excludedSubdivisions.length
            ? `SUBDIVISION: Excluded: ${excludedSubdivisions.map(s => s.label).join(", ").slice(0, 45)}${excludedSubdivisions.map(s => s.label).join(", ").length > 45 ? "..." : ""}`
            : "SUBDIVISION";

    const subdivisionTooltip =
        excludedSubdivisions.length ? `Excluded:\n${excludedSubdivisions.map(s => s.label).join("\n")}` : "";

    /* ================= SELECT ALL HANDLERS ================= */

    // ZONE
    const handleZoneChange = (selected) => {
        if (!selected) {
            handleFilterChange("zone")([]);
            return;
        }

        if (selected.some(o => o.value === "__ALL__")) {
            const allSelected =
                filters.zone.length === zoneOptions.length;

            handleFilterChange("zone")(
                allSelected ? [] : zoneOptions
            );
            return;
        }

        handleFilterChange("zone")(selected);
    };


    // SUBDIVISION
    const handleSubdivisionChange = (selected) => {
        if (!selected) {
            handleFilterChange("subdivision")([]);
            return;
        }

        if (selected.some(o => o.value === "__ALL__")) {
            const allSelected =
                filters.subdivision.length === subdivisionOptions.length;

            handleFilterChange("subdivision")(
                allSelected ? [] : subdivisionOptions
            );
            return;
        }

        handleFilterChange("subdivision")(selected);
    };


    // CUSTOMER / GROUP PARTY
    const handleCustomerChange = (selected) => {
        if (!selected) {
            handleFilterChange("customerName")([]);
            return;
        }

        if (selected.some(o => o.value === "__ALL__")) {
            const allSelected =
                filters.customerName.length === customerNameOptions.length;

            handleFilterChange("customerName")(
                allSelected ? [] : customerNameOptions
            );
            return;
        }

        handleFilterChange("customerName")(selected);
    };

    const numberFields = [
        "L47",
        "M47",
        "L60",
        "M60",
        "L90",
        "M90",
        "L120",
        "M120",
        "AS_ON_DATE",
        "L180",
        "M180",
        "L365",
        "M365",
        "G_AMT",
        "UAC_DD",
        "UAC_CN",
        "NET_AMT"
    ];

    const grandTotals = numberFields.reduce((acc, key) => {
        acc[key] = outstandingData.reduce((sum, row) => {
            const val = Number(row[key]);
            return sum + (isNaN(val) ? 0 : val);
        }, 0);
        return acc;
    }, {});


    return (
        <>
            {/* ---------- LOADER ---------- */}
            {cloading && (
                <div className="overlay">
                    <Loader />
                    <span style={{ marginLeft: 10 }}>Data loading...</span>
                </div>
            )}

            <ZoomWrapper>
                <div className={isFromApp ? "" : "bg" } style={{ display: "block", zoom: "90%", position: 'relative'  }}>

                    {/* ---------- PAGE TITLE ---------- */}
                    <div style={{ textAlign: "center" }}>
                    {!isFromApp && (<span className="font20">OUTSTANDING REPORTS</span>)}

                    {!isFromApp && (  <div className="orderrow"></div> )}

                        {/* ---------- INFO HEADER ---------- */}
                        <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
                            <Typography
                                variant="body1"
                                sx={{
                                    textAlign: "center",
                                    color: "#444",
                                    // lineHeight: 1.6,
                                    // wordSpacing: "2px"
                                }}
                            >
                                DIVISION WISE OUTSTANDING DASHBOARD{" "}
                                {divisionlist
                                    ? divisionlist
                                        .split(",")
                                        .map(d => d.trim().toUpperCase())
                                        .join(", ")
                                    : "--"}
                                {" "}
                                AS ON : {todaysDate || "--"}
                            </Typography>
                        </Paper>


                        {/* ================= FILTERS ================= */}
                        <Grid container spacing={2} sx={{ mb: 3 }}>


                            {/* SUBDIVISION */}
                            <Grid item xs={12} md={3}>
                                <div title={subdivisionTooltip}>
                                    <Select
                                        options={addSelectAllOption(subdivisionOptions)}
                                        value={filters.subdivision}
                                        onChange={handleSubdivisionChange}

                                        inputValue={subdivisionSearchText}
                                        onInputChange={(val, { action }) => {
                                            if (action === "input-change") {
                                                setSubdivisionSearchText(val);
                                            }
                                            if (action === "set-value") {
                                                return subdivisionSearchText;
                                            }
                                            return val;
                                        }}

                                        isMulti
                                        isClearable={Boolean(subdivisionSearchText)}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        controlShouldRenderValue={false}

                                        components={{
                                            Option: CheckboxOption,
                                            MultiValue: NoMultiValue,
                                            ClearIndicator: SubdivisionClearIndicator
                                        }}

                                        placeholder={subdivisionPlaceholder}
                                        onMenuOpen={() => setIsSubdivisionOpen(true)}
                                        onMenuClose={() => setIsSubdivisionOpen(false)}
                                        styles={singleLineSelectStyles}
                                        menuPortalTarget={document.body}
                                    />


                                </div>

                            </Grid>

                            {/* ZONE (WITH AMOUNT) */}
                            <Grid item xs={12} md={3}>
                                <div title={zoneTooltip}>
                                    <Select
                                        options={addSelectAllOption(zoneOptions)}
                                        value={filters.zone}
                                        onChange={handleZoneChange}

                                        inputValue={zoneSearchText}
                                        onInputChange={(val, { action }) => {
                                            if (action === "input-change") {
                                                setZoneSearchText(val);
                                            }
                                            if (action === "set-value") {
                                                return zoneSearchText;   // preserve typed text
                                            }
                                            return val;
                                        }}

                                        isMulti
                                        isClearable={Boolean(zoneSearchText)}     // ✅ show ❌ only when typing
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        controlShouldRenderValue={false}

                                        components={{
                                            Option: CheckboxOption,
                                            MultiValue: NoMultiValue,
                                            ClearIndicator: ZoneClearIndicator
                                        }}

                                        placeholder={zonePlaceholder}
                                        onMenuOpen={() => setIsZoneOpen(true)}
                                        onMenuClose={() => setIsZoneOpen(false)}
                                        styles={singleLineSelectStyles}
                                        menuPortalTarget={document.body}
                                    />


                                </div>
                            </Grid>

                            {/* GROUP PARTY */}
                            <Grid item xs={12} md={4}>
                                <div title={customerTooltip}>
                                    <Select
                                        options={addSelectAllOption(customerNameOptions)}
                                        value={filters.customerName}
                                        onChange={handleCustomerChange}

                                        inputValue={customerSearchText}
                                        onInputChange={(val, { action }) => {
                                            if (action === "input-change") {
                                                setCustomerSearchText(val);
                                            }
                                            if (action === "set-value") {
                                                return customerSearchText;
                                            }
                                            return val;
                                        }}

                                        isMulti
                                        isClearable={Boolean(customerSearchText)}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        controlShouldRenderValue={false}

                                        components={{
                                            Option: CheckboxOption,
                                            MultiValue: NoMultiValue,
                                            ClearIndicator: CustomerClearIndicator
                                        }}

                                        placeholder={customerPlaceholder}
                                        onMenuOpen={() => setIsCustomerOpen(true)}
                                        onMenuClose={() => setIsCustomerOpen(false)}
                                        styles={singleLineSelectStyles}
                                        menuPortalTarget={document.body}
                                    />

                                </div>
                            </Grid>

                            {/* DATE RANGE */}
                            <Grid item xs={12} md={2} sx={{ position: "relative" }}>
                                <TextField
                                    placeholder="DATE RANGE"
                                    value={
                                        range[0].startDate && range[0].endDate
                                            ? `${range[0].startDate.toLocaleDateString("en-GB")} - ${range[0].endDate.toLocaleDateString("en-GB")}`
                                            : ""
                                    }
                                    onClick={() => setShowCalendar(!showCalendar)}
                                    readOnly
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: range[0].startDate && (
                                            <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation(); // calendar open hone se roke
                                                    clearDateRange();
                                                }}
                                            >
                                                <Clear fontSize="small" sx={{ color: "#666" }} />
                                            </IconButton>
                                        ),
                                    }}
                                    fullWidth
                                    sx={{
                                        backgroundColor: "#fff",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                    }}
                                />

                                {showCalendar && (
                                    <ClickAwayListener onClickAway={() => setShowCalendar(false)}>
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                top: "100%",
                                                left: 0,
                                                zIndex: 9999,
                                                boxShadow: 3,
                                                mt: 1,
                                                backgroundColor: "#fff"
                                            }}
                                        >
                                            <DateRange
                                                ranges={range}
                                                onChange={(item) => {
                                                    setRange([item.selection]);

                                                    handleDateFromChange(
                                                        item.selection.startDate.toLocaleDateString("en-CA")
                                                    );
                                                    handleDateToChange(
                                                        item.selection.endDate.toLocaleDateString("en-CA")
                                                    );

                                                    setShowCalendar(false);
                                                }}
                                                maxDate={new Date()}
                                            />
                                        </Box>
                                    </ClickAwayListener>
                                )}
                            </Grid>

                        </Grid>


                        {/* Charts */}
                        <Grid container spacing={2} sx={{ mb: 3 }}>
                            <Grid item xs={12} md={4}>
                                <Paper elevation={3} sx={{ p: 1 }}>
                                    <Typography
                                        variant="subtitle1"
                                        align="center"
                                        sx={{ mb: 1, fontWeight: 600 }}
                                    >
                                        TOTAL NET OUT-STANDING (AMT IN LAC)
                                    </Typography>

                                    <NetAmountLineChart data={summaryGraph} />
                                </Paper>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Paper elevation={3} sx={{ p: 1 }}>
                                    <Typography
                                        variant="subtitle1"
                                        align="center"
                                        sx={{ mb: 1, fontWeight: 600 }}
                                    >
                                        MORE THAN 90 DAYS (AMT IN LAC)
                                    </Typography>

                                    <MoreThan90DaysChart data={summaryGraph} />
                                </Paper>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <Paper elevation={3} sx={{ p: 1 }}>
                                    <Typography
                                        variant="subtitle1"
                                        align="center"
                                        sx={{ mb: 1, fontWeight: 600 }}
                                    >
                                        MORE THAN 180 DAYS (AMT IN LAC)
                                    </Typography>

                                    <MoreThan180DaysChart data={summaryGraph} />
                                </Paper>
                            </Grid>
                        </Grid>

                        {/* ---------- Table HEADER ---------- */}
                        {/* <Paper elevation={2} sx={{ p: 2, mb: 3 }}> */}
                        <Typography
                            variant="body1"
                            sx={{
                                // textAlign: "center",
                                color: "#ffffff",
                                fontWeight: 500,
                                marginBottom: '9px',
                            }}
                        >
                            CUSTOMER OUTSTANDING REPORT{" "}
                            AS ON : {todaysDate || "--"} (AMT IN LAC)
                        </Typography>

                        {/* </Paper> */}
                        {/* ================= MAIN TABLE ================= */}
                        
                        <Paper>
                            <TableContainer sx={{ overflowX: "auto" }}>
                                
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            {[
                                                // "ZONE",
                                                "CUSTOMER NAME",
                                                "CUSTOMER CODE",
                                                "PC",
                                                "SUBDIVISION",
                                                "L47",
                                                "M47",
                                                "L60",
                                                "M60",
                                                "L90",
                                                "M90",
                                                "L120",
                                                "M120",
                                                "AS ON 31-03-2025",
                                                "L180",
                                                "M180",
                                                "L365",
                                                "M365",
                                                "G AMT",
                                                "UAC DO",
                                                "UAC CN",
                                                "NET AMT"
                                            ].map((h) => (
                                                <TableCell
                                                    key={h}
                                                    align="center"
                                                    sx={{ background: "red", color: "#fff", whiteSpace: "nowrap" }}
                                                >
                                                    {h}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {outstandingData.length ? (
                                            <>
                                                {/* ---------------- DATA ROWS ---------------- */}
                                                {outstandingData.map((r, i) => (
                                                    <TableRow key={i}>
                                                        {/* <TableCell align="center">{r.budat}</TableCell> */}
                                                        {/* <TableCell align="center">{r.zone}</TableCell> */}
                                                        <TableCell align="center">{r.partyName}</TableCell>
                                                        <TableCell align="center">{r.customer_code}</TableCell>
                                                        <TableCell align="center">{r.PC}</TableCell>
                                                        <TableCell align="center">{r.division_display}</TableCell>

                                                        <TableCell align="center">{r.L47}</TableCell>
                                                        <TableCell align="center">{r.M47}</TableCell>
                                                        <TableCell align="center">{r.L60}</TableCell>
                                                        <TableCell align="center">{r.M60}</TableCell>
                                                        <TableCell align="center">{r.L90}</TableCell>
                                                        <TableCell align="center">{r.M90}</TableCell>
                                                        <TableCell align="center">{r.L120}</TableCell>
                                                        <TableCell align="center">{r.M120}</TableCell>
                                                        <TableCell align="center">{r.AS_ON_DATE}</TableCell>
                                                        <TableCell align="center">{r.L180}</TableCell>
                                                        <TableCell align="center">{r.M180}</TableCell>
                                                        <TableCell align="center">{r.L365}</TableCell>
                                                        <TableCell align="center">{r.M365}</TableCell>
                                                        <TableCell align="center">{r.G_AMT}</TableCell>
                                                        <TableCell align="center">{r.UAC_DD}</TableCell>
                                                        <TableCell align="center">{r.UAC_CN}</TableCell>
                                                        <TableCell align="center">{r.NET_AMT}</TableCell>
                                                    </TableRow>
                                                ))}

                                                {/* ---------------- GRAND TOTAL ROW ---------------- */}
                                                <TableRow sx={{
                                                    background: "#f3f3f3", "& td": {
                                                        fontWeight: 700
                                                    }
                                                }}>
                                                    <TableCell colSpan={4} align="center" sx={{ fontWeight: 700 }}>
                                                        GRAND TOTAL
                                                    </TableCell>

                                                    <TableCell align="center">{grandTotals.L47.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.M47.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.L60.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.M60.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.L90.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.M90.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.L120.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.M120.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.AS_ON_DATE.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.L180.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.M180.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.L365.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.M365.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.G_AMT.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.UAC_DD.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.UAC_CN.toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{grandTotals.NET_AMT.toLocaleString("en-IN")}</TableCell>
                                                </TableRow>
                                            </>
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={23} align="center">
                                                    NO DATA FOUND
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>

                                </Table>
                            </TableContainer>
                        </Paper>

                        {/* ---------- PAGINATION ---------- */}
                        <Box sx={{ backgroundColor: "#fff", borderTop: "1px solid #ddd", px: 2 }}>
                            <TablePagination
                                component="div"
                                rowsPerPageOptions={[100]}
                                count={totalRecords}
                                rowsPerPage={100}
                                page={page - 1}
                                onPageChange={handleChangePage}
                            />
                        </Box>
                    </div>
                </div>
            </ZoomWrapper>
        </>
    );
};

export default OutstandingReports;
